import { render, staticRenderFns } from "./UploadAdmin.vue?vue&type=template&id=852e8d50"
import script from "./UploadAdmin.vue?vue&type=script&lang=js"
export * from "./UploadAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports